import { RoomReportExcelState, RoomReportExcelActionTypes, ROOM_REPORT_EXCEL_REQUEST, ROOM_REPORT_EXCEL_SUCCESS, ROOM_REPORT_EXCEL_FAILURE } from "store/reducers/room/getReportExcel/types";

const defaultState: RoomReportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function getReportExcel(state = defaultState, action: RoomReportExcelActionTypes): RoomReportExcelState {
  switch (action.type) {
    case ROOM_REPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ROOM_REPORT_EXCEL_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ROOM_REPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};